import { captureRemixErrorBoundaryError } from "@sentry/remix";
import { Links, Meta, MetaFunction, Outlet, Scripts, ScrollRestoration, useLoaderData, useRouteError } from "@remix-run/react";
import type { LinksFunction, LoaderFunction } from "@remix-run/cloudflare";
import { Toaster } from "sonner";
import { rootAuthLoader } from "@clerk/remix/ssr.server";
import { ClerkApp } from "@clerk/remix";
import ReactGA from "react-ga4";

import styles from "./tailwind.css?url"
import { ThemeProvider } from "~/components/theme-provider";
import { useEffect } from "react";


export const links: LinksFunction = () => [
  { rel: "stylesheet", href: styles },
  { rel: "preconnect", href: "https://fonts.googleapis.com" },
  {
    rel: "preconnect",
    href: "https://fonts.gstatic.com",
    crossOrigin: "anonymous",
  },
  {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap",
  },
  { rel: "icon", type: "image/png", href: "/favicon-96x96.png", sizes: "96x96" },
  { rel: "icon", type: "image/svg+xml", href: "/favicon.svg" },
  { rel: "shortcut icon", href: "/favicon.ico" },
  { rel: "apple-touch-icon", sizes: "180x180", href: "/apple-touch-icon.png" },
  { rel: "manifest", href: "/site.webmanifest" },
];

export const loader: LoaderFunction = (args) => rootAuthLoader(args, ({ context }) => {
  return {
    ENV: {
      ENV_NAME: context.cloudflare.env.ENV_NAME,
      GOOGLE_CLIENT_ID: context.cloudflare.env.GOOGLE_CLIENT_ID,
    } as FrontendEnv,
  };
});

export const meta: MetaFunction = () => {
  return [
    { title: "Product Radar - Find Your Interest Products Early" },
    { name: "description", content: "Input your products or interest products descriptio, and when it comes to market, Product Radar will find your related products as early as possible." },
  ];
};

export function Layout({ children }: { children: React.ReactNode }) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data: any = useLoaderData<typeof loader>();
  // console.log("🚀 ~ Layout ~ data:", data);

  useEffect(() => {
    if (data.ENV.GOOGLE_CLIENT_ID) {
      ReactGA.initialize(data.ENV.GOOGLE_CLIENT_ID);
    }
  }, [data?.ENV?.GOOGLE_CLIENT_ID]);

  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Meta />
        <Links />
      </head>
      <body>
        <ThemeProvider
          attribute="class"
          defaultTheme="dark"
          disableTransitionOnChange
        >
          {children}
          {/* <Outlet /> */}
          <Toaster richColors/>
        </ThemeProvider>
        <ScrollRestoration />
        <script
          dangerouslySetInnerHTML={{
            __html: `window.ENV = ${JSON.stringify(
              data?.ENV ?? {}
            )}`,
          }}
        />
        <Scripts />
      </body>
    </html>
  );
}

function App() {
  return <Outlet />;
}

export const ErrorBoundary = () => {
  const error = useRouteError();
  captureRemixErrorBoundaryError(error);
  return <div>Something went wrong</div>;
};

export default ClerkApp(App, {
  afterSignInUrl: "/dashboard",
});